import type { Tables } from '~/types/database-helpers';
import { type User } from '@supabase/gotrue-js/src';
import { ConferencesService } from '~/lib/services/conferences.service';

export type Conference = Tables<'conferences'>;
export const useConferencesStore = defineStore('conferences', {
  state: (): {
    conferences: Conference[];
    total: number;
    pageCount: number;
  } => ({
    conferences: [],
    total: 0,
    pageCount: 0,
  }),
  actions: {
    setTotal(total: number) {
      this.total = total;
    },
    setPageCount(count: number) {
      this.pageCount = count;
    },
    async fetchConferences(): Promise<Conference[] | null> {
      try {
        const supabase = useSupabaseClient();
        const conferencesService = new ConferencesService(supabase);
        const { data } = await conferencesService.findAll({
          perPage: 4000,
          sort: { field: 'abbreviation', ascending: true },
        });
        if (data) {
          this.setConferences(data);
        }
        return data;
      } catch (error: any) {
        console.error(error);
        return null;
      }
    },
    setConferences(conferences: Conference[]) {
      this.conferences = conferences;
    },
  },
});
